module.exports = __webpack_public_path__ + "static/media/sernac.17cdf375.jpg";